import { useEffect, useState } from "react";

export default function BackToTop({ hidden = false }: { hidden?: boolean }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const update = () => setVisible(window.scrollY >= window.innerHeight);
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);
  if (!visible || hidden) return null;
  return <button type="button" className="back-to-top" aria-label="回到顶部" title="回到顶部" onClick={() => {
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: reducedMotion ? "instant" : "smooth" });
  }}>
    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 10l6-6 6 6M12 4v16" /></svg>
  </button>;
}
